/**
 *      Arquivo responsável por guardar todos os end-point que serão requisitados
 *          pelo módulo
 */
export default {
    putOpinionGrade: { method: 'put', url: 'api/secure/common/opinion_grade' },
    postOpinionGrade: { method: 'post', url: 'api/secure/common/opinion_grade' },
    getAllOpinionGrade: { method: 'get', url: 'api/secure/common/opinion_grade' },
    delAllOpinionGrade: { method: 'delete', url: 'api/secure/common/opinion_grade/{id}' },
}